import {
  DashboardDataGridContained,
  DashboardhMediumButton,
  DashboardInput,
} from 'bd-web-components'
import { Dispatch, useCallback, useEffect, useState } from 'react'
import {
  DataGridContainer,
  MessageInfo,
  ExceptionContainer,
  MessageContainer,
  MessageInfoBold,
} from '../styles'
import { DesktopHidder, InputWider, MobileButtonBox } from './styles'
import { useSiteUserValidate } from '../../../../hooks/validate-user'
import * as EmailValidator from 'email-validator'
import { cpf } from 'cpf-cnpj-validator'
import { useDebounce } from 'usehooks-ts'
import useSWRMutation from 'swr/mutation'
import Loader from '../../../../components/Loader'
import { FlowButtonControl } from '../../../../components/FlowButtonControl'
import { toast } from 'react-toastify'
import {
  GRAY_SCALE_09,
  PRIMARY_BLUE_03,
  SECONDARY_BLUE_01,
} from 'bd-web-components/src/utils/dash-colors'
interface TicketSelectorComponentProps {
  useFormikProps: any
  handleButtonClick: () => void
  rollBack: () => void
  setUserData: Dispatch<any>
  name: string
  data: any[]
  userData: any
}

export const UserSelector = ({
  name,
  useFormikProps,
  rollBack,
  setUserData,
  userData,
  handleButtonClick,
}: TicketSelectorComponentProps) => {
  const debounced = useDebounce('', 800)
  const [debouncedValue, setDebouncedValue] = useState<string>('')
  const [value, setValue] = useState<string>('')
  const [notRegistered, setNotRegistered] = useState(false)
  const [isEmail, setIsEmail] = useState(true)
  const error = useFormikProps.errors[name] === undefined

  const { fetcher } = useSiteUserValidate()
  const { trigger, isMutating } = useSWRMutation(
    {
      identifier: debouncedValue,
      mode: cpf.isValid(debouncedValue) ? 'cpf' : 'email',
    },
    fetcher
  )

  const userDataModeler = (data: any) => {
    const clone = Object.assign({}, data)
    delete clone.cpf_nao_formatado
    delete clone.id
    return Object.keys(clone).map((key) => {
      const title = key.charAt(0).toUpperCase() + key.slice(1)
      return {
        title: title,
        value: clone[key],
      }
    })
  }

  const handlerButtonClickUpdate = () => {
    useFormikProps.setFieldValue(name, value).then(() => {
      handleButtonClick()
    })
  }

  const onSubmit = useCallback(async () => {
    try {
      setUserData({
        success: false,
        data: {
          cpf: '',
          email: '',
          id: 0,
          nome: '',
        },
        dataAsArray: [],
      })
      setNotRegistered(false)
      const result = await trigger()
      const { data } = result
      if (data.success) {
        data.dataAsArray = userDataModeler(data.data)
        setUserData(data)
      }
    } catch (error: any) {
      if (error !== undefined) {
        if (error.response !== undefined) {
          const { data } = error.response
          const { errorCode } = data
          if (errorCode === 404) {
            setNotRegistered(true)
            setIsEmail(EmailValidator.validate(value))
            const notRegisterdData: any = {
              success: false,
              data: {
                cpf: 'Não informado',
                cpf_nao_formatado: 'Não informado',
                email: value,
                id: 0,
                nome: 'Não informado',
              },
              dataAsArray: [],
            }

            notRegisterdData.dataAsArray = userDataModeler(
              notRegisterdData.data
            )
            notRegisterdData.data.cpf = ''
            notRegisterdData.data.cpf_nao_formatado = ''
            notRegisterdData.data.nome = ''

            setUserData(notRegisterdData)
          } else {
            toast.error('Um erro aconteceu, tente novamente')
          }
        }
      }
    }
  }, [value, trigger, setUserData, setIsEmail])

  useEffect(() => {}, [setUserData])

  useEffect(() => {
    if (cpf.isValid(value) || EmailValidator.validate(value)) {
      setDebouncedValue(value)
    }
  }, [value, useFormikProps, name])

  useEffect(() => {
    if (
      cpf.isValid(debouncedValue) ||
      EmailValidator.validate(debouncedValue)
    ) {
      onSubmit()
    }
  }, [debounced, debouncedValue, onSubmit])

  return (
    <>
      <MobileButtonBox>
        <InputWider>
          <DashboardInput
            title={'Email ou CPF'}
            type={'input'}
            name={name}
            disabled={false}
            placeholder={'Email ou CPF'}
            error={
              !cpf.isValid(value) &&
              !EmailValidator.validate(value) &&
              value !== ''
            }
            success={cpf.isValid(value) || EmailValidator.validate(value)}
            errorMsg={'Por favor, insira um Email ou CPF válido'}
            value={value}
            onChange={(e: any) => {
              const t = e.target.value
              setValue(t)
              if (
                !cpf.isValid(debounced) ||
                !EmailValidator.validate(debounced)
              ) {
                setUserData({
                  success: false,
                  data: {
                    cpf: '',
                    email: '',
                    id: 0,
                    nome: '',
                  },
                  dataAsArray: [],
                })
                setNotRegistered(false)
              }
            }}
            onBlur={useFormikProps.handleBlur}
          />
        </InputWider>
        <DesktopHidder>
          <DashboardhMediumButton
            onClick={handlerButtonClickUpdate}
            background={
              userData.success || notRegistered
                ? SECONDARY_BLUE_01
                : GRAY_SCALE_09
            }
            color={userData.success || notRegistered ? '#fff' : PRIMARY_BLUE_03}
            height="60px"
            maxWidth="100%"
            variant={
              userData.success || notRegistered ? 'contained' : 'disabled'
            }
          >
            {'Avançar'}
          </DashboardhMediumButton>
        </DesktopHidder>
      </MobileButtonBox>
      <DataGridContainer className="user">
        {userData.success && !isMutating && error && !notRegistered && (
          <DashboardDataGridContained data={userData.dataAsArray} />
        )}
        {isMutating && (
          <ExceptionContainer height={200} margin={false}>
            <Loader />
          </ExceptionContainer>
        )}
        {!userData.success && !isMutating && error && notRegistered && (
          <MessageContainer>
            <MessageInfo>
              Informamos que não encontramos um cadastro com esse cpf ou e-mail
              na Bilheteria Digital.
            </MessageInfo>

            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <MessageInfoBold>A cortesia&nbsp;</MessageInfoBold>
              <MessageInfo>
                {isEmail
                  ? 'será enviada para o e-mail fornecido.'
                  : 'não pode ser enviada para um cpf não cadastrado'}
              </MessageInfo>
            </div>
          </MessageContainer>
        )}
      </DataGridContainer>
      <FlowButtonControl
        rollback={rollBack}
        flowControl={userData.success || (notRegistered && isEmail)}
        // flowControl={userData.success || (notRegistered && !isEmail)}
        action={handlerButtonClickUpdate}
      />
    </>
  )
}
